import { Validators } from '@angular/forms';

export const SingleFileForm = {
    file: ['', [
        Validators.required
    ]],
    fileSource: ['', [
        Validators.required
    ]]
}